import React, {useState} from 'react';

import {Button, Col, DatePicker, Form, Input, InputNumber, Radio, Row, Select, Space, Switch, Typography} from 'antd';
import {UserCategory, UserGender, UserGrade} from '../../hooks/apis/useUser';
import {KnowledgeTestStatusConfig} from '../../hooks/apis/useKnowledgeTest';
import moment, {Moment} from 'moment';
import KnowledgeBankSelect from '../KnowledgeBank/Select';

const {Text, Title, Paragraph} = Typography;

export interface IKnowledgeTestEditForm {
  id: number;
  beginTime: Moment;
  endTime: Moment;
  singleBankId: number;
  singleAmount: number;
  singleScore: number;
  multiBankId: number;
  multiAmount: number;
  multiScore: number;
  timeLimit: number;
  remark: string;
  statusConfig: KnowledgeTestStatusConfig;
}

const KnowledgeTestEditForm = (props: {form: IKnowledgeTestEditForm; isLoading: boolean; onFinish: (value: IKnowledgeTestEditForm) => any}) => {
  const [form] = Form.useForm();
  const [statusConfig, setStatusConfig] = useState<KnowledgeTestStatusConfig>(KnowledgeTestStatusConfig.自动);

  React.useEffect(() => {
    form.setFieldsValue(props.form);
    setStatusConfig(props.form.statusConfig);
  }, [props.form]);

  return (
    <Form
      labelCol={{span: 6}}
      wrapperCol={{span: 14}}
      layout={'horizontal'}
      form={form}
      onFinish={value => {
        value.id = props.form.id;
        value.statusConfig = statusConfig;
        props.onFinish(value as IKnowledgeTestEditForm);
      }}>
      <Form.Item label={'起始时间'} name={'beginTime'} rules={[{required: true}]}>
        <DatePicker size={'large'} showTime placeholder="请输入起始时间" />
      </Form.Item>
      <Form.Item label={'结束时间'} name={'endTime'} rules={[{required: true}]}>
        <DatePicker size={'large'} showTime placeholder="请输入结束时间" />
      </Form.Item>
      <Form.Item label={'通道开关'} required>
        <Radio.Group value={statusConfig} onChange={e => setStatusConfig(e.target.value)}>
          <Radio value={KnowledgeTestStatusConfig.开启}>开启</Radio>
          <Radio value={KnowledgeTestStatusConfig.关闭}>关闭</Radio>
          <Radio value={KnowledgeTestStatusConfig.自动}>根据起始时间自动</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item label={'单选题题库'} name={'singleBankId'} rules={[{required: true}]}>
        <KnowledgeBankSelect />
      </Form.Item>
      <Form.Item label={'单选题数量'} name={'singleAmount'} rules={[{required: true}]}>
        <InputNumber size={'large'} min={0} max={100} />
      </Form.Item>
      <Form.Item label={'单选题分值'} name={'singleScore'} rules={[{required: true}]}>
        <InputNumber size={'large'} min={0} max={10} />
      </Form.Item>
      <Form.Item label={'多选题题库'} name={'multiBankId'} rules={[{required: true}]}>
        <KnowledgeBankSelect />
      </Form.Item>
      <Form.Item label={'多选题数量'} name={'multiAmount'} rules={[{required: true}]}>
        <InputNumber size={'large'} min={0} max={100} />
      </Form.Item>
      <Form.Item label={'多选题分值'} name={'multiScore'} rules={[{required: true}]}>
        <InputNumber size={'large'} min={0} max={10} />
      </Form.Item>
      <Form.Item label={'答题时长'} name={'timeLimit'} rules={[{required: true}]}>
        <InputNumber size={'large'} min={0} max={60} />
      </Form.Item>
      <Form.Item label={'备注'} name={'remark'}>
        <Input.TextArea />
      </Form.Item>
      <Row>
        <Col span={6} />
        <Col>
          <Space>
            <Button size={'large'} type="primary" loading={props.isLoading} htmlType="submit" className="login-form-button">
              保存
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default KnowledgeTestEditForm;
